import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-term-he',
  templateUrl: './term-he.component.html',
  styleUrls: ['./term-he.component.css']
})
export class TermHeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
